/**
 * An Error which affects the whole app and needs handling within that scope
 *
 * Only add errors which affect the whole app here. Smaller or more specific errors can be handled
 * in other parts of the application only affecting them.
 */
export enum AppError {
    /** App fails to load a layout */
    LAYOUT_LOAD_FAILED = 'LAYOUT_LOAD_FAILED',
    CONFIGURATION_LOAD_FAILED = 'CONFIGURATION_LOAD_FAILED',
    //** App fails to load product data for configuration */
    CONFIGURATION_DATA_LOAD_FAILED = 'CONFIGURATION_DATA_LOAD_FAILED',
    ADD_TO_CART_UNDEFINED = 'ADD_TO_CART_UNDEFINED',
    /** App fails to download or decode product data */
    PRODUCT_DATA_FAILED = 'PRODUCT_DATA_FAILED',
}
